<template>
	<div class="teaching-plan flex start-v">
		<div class="head flex center">
			<p class="flex">
				如需增加教案，烦请老师前往
				<span>PC端</span>
			</p>
		</div>

		<div v-if="planList.length===0" class="nodata-page" data-msg="暂时没有教案信息哦~"></div>
		<div v-bottom="nextPage" class="list">
			<div @click="toDetails(item)" v-for="(item,index) in planList" :key="index" class="card">
				<p class="title text-ellipsis">{{item.name}}</p>
				<p>上传时间: {{item.createTime}}</p>
			</div>
			<div v-if="pages&&pages==params.pageNo" class="scroll-end"></div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			params: {
				teamId: undefined,
				pageNo: 1,
				pageSize: 10,
			},
			pages: 0,
			planList: [],
		};
	},

	mounted() {
		this.params.teamId = this.$route.query.gradeId;
		this.getPlans();
	},

	methods: {
		toDetails(item) {
			let params = {};
			params.planId = item.id;
			params.gradeId = this.$route.query.gradeId;
			this.$router.push({path:"/manager/course/grade/teachingplan/details",query:params});
		},

		nextPage() {
			if (this.params.pageNo === this.pages) return;
			this.params.pageNo += 1;
			this.getPlans();
		},

		async getPlans() {
			try {
				let {success,message,result} = await this.$http.get("h5/preview/list",{params:this.params})
				if (!success) throw new Error(message);
				this.pages = result.pages;
				this.planList = this.planList.concat(result.records);
			} catch (error) {
				console.error("getPlans", error?.message);
			}
		},
	},
};
</script>


<style lang="less" scoped>
.teaching-plan {
	height: 100%;
	.head {
		width: 100%;
		padding: 11 / @rem 17 / @rem 5 / @rem;
		p {
			width: 100%;
			height: 37 / @rem;
			border-radius: 12 / @rem;
			box-shadow: 0 3 / @rem 17 / @rem 0 rgba(143, 72, 0, 0.2);
			letter-spacing: 1 / @rem;
			justify-content: center;
			span {
				color: #ffa216;
			}
		}
	}

	.list {
		width: 100%;
		padding: 0 17 / @rem;
		flex: 1;
		overflow-y: auto;
	}
	.card {
		box-shadow: 0 3 / @rem 17 / @rem 0 rgba(143, 72, 0, 0.2);
		border-radius: 12 / @rem;
		padding: 16 / @rem 35 / @rem 16 / @rem 16 / @rem;
		background-color: white;
		position: relative;
		margin-top: 11 / @rem;
		p {
			width: 100%;
			font-weight: bold;
			letter-spacing: 1 / @rem;
			&:last-child {
				padding-top: 8 / @rem;
				font-size: 11 / @rem;
				font-weight: normal;
				color: rgba(31, 30, 29, 0.3);
			}
		}
		&::after {
			content: "";
			display: block;
			position: absolute;
			right: 5 / @rem;
			top: 50%;
			margin-top: -8 / @rem;
			width: 15 / @rem;
			height: 15 / @rem;
			position: absolute;
			background-image: url(~@img/icon/btn_xl.png);
			background-repeat: no-repeat;
			background-size: contain;
		}
	}
}
</style>
